import {Fragment} from "react";
import classNames from "classnames";
import {VideoControl} from "../model/types";
import {PlayButton} from "../ui/PlayButton";
import {VolumeButton} from "../ui/VolumeButton";
import {normalizeControls} from "../lib/normalizeControls";
import styles from "../ui/Video.module.scss";

type Props = {
    controls?: boolean | VideoControl[];
    muted: boolean;
    playing: boolean;
    onToggleMute: () => void;
    onTogglePlay: () => void;
    className?: string;
}

export const VideoControls = (
    {
        controls,
        playing,
        muted,
        onTogglePlay,
        onToggleMute,
        className,
    }: Props
) => {
    const parsedControls = normalizeControls(controls);

    const controlsMap = {
        play: () => (<PlayButton playing={playing} onClick={onTogglePlay} />),
        volume: () => (<VolumeButton muted={muted} onClick={onToggleMute} />),
    };

    if (!parsedControls.length) return null;

    return (
        <div className={classNames(styles.controls, className)}>
            {parsedControls.map(control => (
                <Fragment key={control}>{controlsMap[control]?.()}</Fragment>
            ))}
        </div>
    );
}
